import type { MessageChannel } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { MessageChannelReadable } from "../ui/thread-channel-ui";
import { ThreadHeader } from "./thread-header";

// TODO: remove this component once we suport all channel types
/**
 * Placeholder component for channel types that don't have a dedicated view yet.
 * Displays the thread header and a message indicating the channel is not yet supported.
 */
export const UnsupportedThreadView = memo(function UnsupportedThreadView({
  channel,
}: {
  channel: MessageChannel;
}) {
  const displayName = MessageChannelReadable[channel];

  return (
    <Flex dir="column" gap="none">
      <ThreadHeader channel={channel} subject={null} />
      <Flex
        align="center"
        bgColor="primary"
        borderBottomWidth="1px"
        borderColor="primary"
        borderLeftWidth="1px"
        borderRightWidth="1px"
        borderStyle="solid"
        bottomLeftRadius="sm"
        bottomRightRadius="sm"
        dir="column"
        gap="md"
        p="xl"
        topLeftRadius="none"
        topRightRadius="none"
      >
        <Text fontSize="md" textColor="secondary">
          {displayName} is not yet supported
        </Text>
      </Flex>
    </Flex>
  );
});
